// data: object, keys: array
export const validateKeys = (data, keys) => {
  if (data && keys?.length > 0) {
    return keys.every(key => key in data)
  } else {
    return false
  }
}
